import '../App.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import UserRegister from '../model/request/UserRegister';
import { useEffect, useState } from 'react';
import TopBar from './TopBar';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import LookUpRequest from "../model/request/LookupRequest";
import logo from '../images/logo.jpeg';
import Offeradd from './Offeradd.js';




function Religion() {

    var location = useLocation();
    var { userRegister } = location.state || {};

    const navigation = useNavigate()
    // var userObject = userRegister;


    var [Religion, setReligion] = useState("");
    var [ReligionError, setReligionError] = useState();

    var [casteList, setCasteList] = useState([]);

    var [Caste, setCaste] = useState("");
    var [CasteError, setCasteError] = useState();

    var [Subcaste, setSubcaste] = useState("");
    var [SubcasteError, setSubcasteError] = useState();

    var [Gothram, setGothram] = useState("");
    var [GothramError, setGothramError] = useState();


    useEffect(() => {
        if (userRegister == null) {
            navigation('/');
        }
    }, [userRegister, navigation]);
    if (!userRegister) {
        return null; // render nothing briefly
    }
    var userObject = Object.setPrototypeOf(userRegister, UserRegister.prototype);
    
    function casteAPICall(religionId) {
        var request = new LookUpRequest();
        request.religion_id = religionId;
        console.log("Response:", JSON.stringify(request));
        axios.post(
            ApiConfig.getUrl("User/caste"),
            JSON.stringify(request),
            {
                headers: {
                    "Content-Type": "application/json",
                }
            }
        )
            .then(response => {
                console.log("Responsesadsadsad:", response.data.response);
                const dataList = response.data.response.dataList;
                console.log("Responsesa:", dataList);
                setCasteList(dataList)

            })
            .catch(error => {
                console.error("Error:", error);
            });
    }


    function clicktoPersonalscreen() {

        if (validation()) {

            userObject.religion = parseInt(Religion);
            userObject.caste = 1;
            userObject.sub_Caste = "1";
            userObject.gothram = "1";
            userObject.cast = parseInt(Caste);
            userObject.sub_Cast = Subcaste;
            userObject.gothram = Gothram;

            navigation('/Personal', { state: { userObject } })

        }
    }
    function validation() {

        var isFlage = true

        if (Religion == "") {
            setReligionError("Select Your Religion.")
            isFlage = false
        }
        else {

            setReligionError("")
        }

        if (Caste == "") {
            setCasteError("Select Your Caste.")
            isFlage = false
        }
        else {
            setCasteError("")
        }
        // if (Subcaste.trim() == "" && Caste != "") {
        //     setSubcasteError("Please enter your subcaste")
        //     isFlage = false
        // }
        // else {
        //     setSubcasteError("")
        // }
        // if (Gothram.trim() == "" && Caste != "") {
        //     setGothramError("Please enter your gothram")
        //     isFlage = false
        // }
        // else {
        //     setGothramError("")
        // }
        return isFlage;
    }

     const disableRightClick = (e) => {
    e.preventDefault();
  };

    return (
        <>

            <div className='fullview'  onContextMenu={disableRightClick}>
                <TopBar />
                <div className='container mt-4'>
                    <div className='row mt-5 align-items-center gx-0'>
                        <div className="col-lg-5 col-12  p-4 d-flex justify-content-center align-items-center mt-3">
                            <img className='image h-100 w-100' src={logo} alt='logo' />
                        </div>

                        <div className="col-lg-6 col-12 card p-3">
                            <p className="h5 text-center mt-2 pt-2">Religion Details</p>


                            {/* <label htmlFor="Religion" className="Religion">Religion </label> */}

                            <select id="Religion" className="form-control mt-2" value={Religion}

                                onChange={(e) => {
                                    setReligion(e.target.value)
                                    // if(e.target.value!=""){
                                    casteAPICall(parseInt(e.target.value))
                                    // }
                                }} >
                                <option value="">Please Select Religion</option>
                                <option value="1">Hindu</option>
                                <option value="2">Muslim</option>
                                <option value="3">Muslim - Shia</option>
                                <option value="4">Muslim - Sunni</option>
                                <option value="6">Christian</option>
                                <option value="7">Sikh</option>
                                <option value="8">Jain - All</option>
                                <option value="9">Jain - Digambar</option>
                                <option value="10">Jain - Shwetambar</option>
                                <option value="12">Parsi</option>
                                <option value="13">Buddhist</option>
                                <option value="14">Jewish</option>
                                <option value="15">Inter-Religion</option>
                                <option value="16">No Religious Belief</option>

                            </select>
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }} >{ReligionError}</span>
                            {/* <label htmlFor="Cast" className="Cast"  >Cast </label> */}
                            <select id="Caste" className="form-control mt-2" value={Caste}
                                onChange={(e) => {
                                    setCaste(e.target.value)

                                }}>
                                <option value="">Please Select Caste</option>
                                {casteList.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            <span className="mt-2 text-danger text-decoration-none" style={{ letterSpacing: "1px" }}>{CasteError}</span>

                            {Caste !== "" && (
                                <>
                                    {/* <label htmlFor="Subcast" className="label">Subcast </label> */}
                                    <input type="text" id="subcaste" className="form-control mt-2" placeholder='Subcaste' value={Subcaste} onChange={(e) => setSubcaste(e.target.value)} />


                                    {/* <label htmlFor="Gothram" className="label">Gothram </label> */}
                                    <input type="text" id="Gothram" className="form-control mt-3"
                                        placeholder='Gothram'
                                        value={Gothram} onChange={(e) => setGothram(e.target.value)} />


                                </>
                            )}

                            <button onClick={clicktoPersonalscreen} type="button" className="btn w-100 mt-4 text-light"  style={{backgroundColor:"var(--primary-color)",fontWeight:"bold"}} >Next page</button>


                        </div>
                    </div>
                    <Offeradd/>
                </div>

            </div>
            <footer className='bg-dark text-white text-center '>
                <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
            </footer>
        </>

    );
}
export default Religion;